import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "addAction", "action" ]
  static classes = [ "disabled" ]
  static values = {
    taskActionCount: Number,
    emailActionCount: Number,
    tagActionCount: Number,
    giverEmailActionCount: Number,
    workflowActionCount: Number
  }

  connect() {}

  actionTargetConnected(action) {
    let actionType = action.dataset.actionType
    let count = this[`${actionType}ActionCountValue`] += 1
    let link = this.actionLink(actionType)

    if (link && count >= action.dataset.limit) {
      link.classList.add(...this.disabledClasses);
    }
  }

  actionTargetDisconnected(action) {
    let actionType = action.dataset.actionType
    let count = this[`${actionType}ActionCountValue`] -= 1
    let link = this.actionLink(actionType)

    if (link && count < action.dataset.limit) {
      link.classList.remove(...this.disabledClasses);
    }
  }

  actionLink(actionType) {
    return this.addActionTargets.find((target) => (target.dataset.actionType == actionType))
  }
}
